module.exports = __webpack_public_path__ + "img/backBanner_pc.607eda2.png";